import React from 'react';

export const IconDeployment = ({ ...args }) => {
  return (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg" {...args}>
      <path
        d="M8.33339 31.0396C6.78556 29.4582 5.61791 27.5452 4.91888 25.4457C4.21985 23.3462 4.00778 21.1151 4.29872 18.9215C4.58967 16.7278 5.37601 14.6292 6.59817 12.7844C7.82033 10.9397 9.44627 9.39732 11.3528 8.27407C13.2594 7.15081 15.3966 6.47615 17.6025 6.30121C19.8084 6.12626 22.0252 6.4556 24.085 7.26429C26.1448 8.07298 27.9935 9.33982 29.4912 10.9688C30.9888 12.5978 32.0961 14.5463 32.7292 16.6667H36.4584C38.4699 16.6664 40.4281 17.3132 42.0438 18.5113C43.6595 19.7095 44.847 21.3956 45.4308 23.3204C46.0147 25.2453 45.964 27.3069 45.2862 29.2008C44.6083 31.0946 43.3394 32.7202 41.6667 33.8375"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M25 25V43.75" stroke="black" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M33.3333 33.3333L25 25L16.6666 33.3333"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
